export default "skymp5-front/13539a8346f3dda28a514088c1807114.gif";